import { render, staticRenderFns } from "./QuestionBox.vue?vue&type=template&id=744cdc76&scoped=true&"
import script from "./QuestionBox.vue?vue&type=script&lang=js&"
export * from "./QuestionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744cdc76",
  null
  
)

export default component.exports